import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { Typeahead } from 'react-bootstrap-typeahead'
import DatePicker from 'react-bootstrap-date-picker'
import {
  Button,
  Col,
  Panel,
  Form,
  FormControl,
  FormGroup,
  Modal,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap'

import Validators from '../utils/validators'
import Dropdown from './dropdown'

@observer(['activities', 'companies', 'tasks', 'users', 'globals'])

export default class TasksDetails extends Component {
  constructor(props) {
    super(props)

    let showEditModal = false
    
    this.props.users.loadAllOrganizationUsers(localStorage.getItem('userOrganizationId'))
    this.props.tasks.loadtaskPriorities()
    this.props.tasks.loadTaskStates()

    if (this.props.taskId > 0) {
      showEditModal = true;
      this.openEdit(this.props.taskId)
    }

    this.state = {
      showDetailsModal: false,
      showEditModal: false,
      taskPriorityId: 0,
      dueDate: '',
      newTask: '',
      editTaskPriorityId: 0,
      editTaskStateId: 0,
      editDueDate: '',
      editTask: '',
      companyPhone: '',
      companyEmail: '',
      formattedDueDate: '',
      assignedUserId: 0,
      assignedUserName: '',
      editAssignedUserId: 0,
      editAssignedUserName: '',
      editNewAssigned: 0,
      ogAssignedUserId: 0
    }
  }

  validateNewTaskForm() {
    if (this.getNewTaskAssignedUserValidationState() == 'error') {
      return false
    }

    if (this.getNewTaskDueDateValidationState() == 'error') {
      return false
    }

    if (this.getNewTaskTaskValidationState() == 'error') {
      return false
    }

    return true
  }

  validateEditTaskForm() {
    if (this.getEditTaskAssignedUserValidationState() == 'error') {
      return false
    }

    if (this.getEditTaskDueDateValidationState() == 'error') {
      return false
    }

    if (this.getEditTaskTaskValidationState() == 'error') {
      return false
    }

    return true
  }

  getNewTaskAssignedUserValidationState() {
    if (this.state && Validators.validString(this.state.assignedUserId)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getEditTaskAssignedUserValidationState() {
    if (this.state && Validators.validString(this.state.editAssignedUserId)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getNewTaskDueDateValidationState() {
    if (this.state && Validators.validString(this.state.dueDate)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getEditTaskDueDateValidationState() {
    if (this.state && Validators.validString(this.state.editDueDate)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getNewTaskTaskValidationState() {
    if (this.state && Validators.validString(this.state.newTask)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getEditTaskTaskValidationState() {
    if (this.state && Validators.validString(this.state.editTask)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  newTaskDueDateChanged(e) {
    let dateString = ''
    if (e) {
      let dd = new Date(e)
      dateString = dd.getUTCFullYear() + '-' + ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2)
    }

    this.setState({
      dueDate: dateString
    })
  }

  editTaskDueDateChanged(e) {
    let editDateString = ''
    if (e) {
      let dd = new Date(e)
      editDateString = dd.getUTCFullYear() + '-' + ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2)
    }

    this.setState({
      editDueDate: editDateString
    })
  }

  newTaskTaskChanged(e) {
    this.setState({
      newTask: e.target.value
    })
  }

  editTaskTaskChanged(e) {
    this.setState({
      editTask: e.target.value
    })
  }

  onTaskPriorityChanged(e) {
    this.setState({
      taskPriorityId: e.target.value
    })
  }

  onEditTaskPriorityChanged(e) {
    this.setState({
      editTaskPriorityId: e.target.value
    })
  }

  onEditTaskStateChanged(e) {
    this.setState({
      editTaskStateId: e.target.value
    })
  }

  onAssignedUserChanged(e) {
    if (e.length > 0) {
      this.setState({
        assignedUserId: e[0].id,
        assignedUserName: e[0].name
      })
    } else {
      this.setState({
        assignedUserId: 0,
        assignedUserName: ''
      })
    }
  }

  onEditAssignedUserChanged(e) {
    if (e.length > 0) {
      if (this.state.ogAssignedUserId != e[0].id) {
        this.setState({
          editNewAssigned: 1
        })
      } else {
        this.setState({
          editNewAssigned: 0
        })
      }
    } else {
        this.setState({
          editNewAssigned: 0
        })
    }

    if (e.length > 0) {
      this.setState({
        editAssignedUserId: e[0].id,
        editAssignedUserName: e[0].name
      })
    } else {
      this.setState({
        editAssignedUserId: 0,
        editAssignedUserName: ''
      })
    }
  }

  openEdit(cell) {
    if (this.state) {
      this.setState({
        showEditModal: true
      })
    }

    this.props.companies.loadTask(cell, (data) => {
      let dd = new Date(data.dueDate)
      let editDateString = dd.getUTCFullYear() + '-' + ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2)

      this.setState({
        showEditModal: true,
        companyPhone: data.company.defaultContact.phone,
        companyEmail: data.company.defaultContact.email,
        editTaskId: data.id,
        editTaskPriorityId: data.taskPriorityId,
        editTaskStateId: data.taskStateId,
        editDueDate: editDateString,
        editTask: data.task,
        editAssignedUserId: data.assignedUserId,
        ogAssignedUserId: data.assignedUserId,
        editAssignedUserName: data.assignedUserName,
        showEditModal: true
      })
    })
  }

  open() {
    this.setState({
      showDetailsModal: true
    })
  }

  closeEdit() {
    this.setState({
      showEditModal: false,
      companyPhone: '',
      companyEmail: '',
      editTaskId: 0,
      editDueDate: '',
      editAssignedUserId: 0,
      editAssignedUserName: '',
      editNewAssigned: 0,
      ogAssignedUserId: 0
    })
  }

  close() {
    this.setState({
      showDetailsModal: false
    })
  }

  newTask(e) {
    if (this.validateNewTaskForm()) {
      this.props.companies.addTask({
        companyId: this.props.companyId,
        userId: this.props.globals.loggedInUser.id,
        assignedUserId: this.state.assignedUserId,
        newAssigned: 1,
        taskPriorityId: document.getElementById('taskPriorityId').value,
        dueDate: document.getElementById('dueDate').getAttribute('data-formattedvalue'),
        task: document.getElementById('newTask').value
      }, (data) => {
        this.close()
        //Log activity //Log activity logNewActivity(userId, activity, activitySectionTypeId, activitySectionId, entityTypeId, entityId)
        this.props.activities.logNewActivity(localStorage.getItem('userId'), 'create', 2, data.addTask.id, 1, this.props.companyId)
      })
      
    } else {
      alert('Please check the form.  Required data is missing.')
    }
  }

  sortByCreatedDate(a, b, order) {
    const aa = a.formattedCreatedDate.split('-')
    const bb = b.formattedCreatedDate.split('-')

    return this.sortByDate(aa, bb, order)
  }

  sortByDueDate(a, b, order) {
    const aa = a.formattedDueDate.split('-')
    const bb = b.formattedDueDate.split('-')

    return this.sortByDate(aa, bb, order)
  }

  sortByDate(aa, bb, order) {
    const fa = aa[2] + aa[0] + aa[1]
    const fb = bb[2] + bb[0] + bb[1]

    if (order == 'desc') {
      return fb - fa
    } else {
      return fa - fb
    }
  }

  updateTask(row, cellName, cellValue) {

    let taskPriorityId = 1
    let taskStateId = 1

    for( let i=0; i<this.props.tasks.data.length; i++ ) {
      if (this.props.tasks.data[i].name == row.priority) {
        taskPriorityId = this.props.tasks.data[i].id
        break
      }
    }

    for( let i=0; i<this.props.tasks.taskStates.length; i++ ) {
      if (this.props.tasks.taskStates[i].name == row.state) {
        taskStateId = this.props.tasks.taskStates[i].id
        break
      }
    }

    this.props.tasks.updateTask({
      id: row.id,
      task: row.task,
      taskPriorityId,
      taskStateId
    })
  }

  saveTask() {
    if (this.validateEditTaskForm()) {
      this.props.companies.updateTask({
        id: this.state.editTaskId,
        assignedUserId: this.state.editAssignedUserId,
        newAssigned: this.state.editNewAssigned,
        taskPriorityId: this.state.editTaskPriorityId,
        taskStateId: this.state.editTaskStateId,
        dueDate: this.state.editDueDate,
        task: this.state.editTask,
        companyId: this.props.companyId
      }, (data) => {
        //Log activity //Log activity logNewActivity(userId, activity, activitySectionTypeId, activitySectionId, entityTypeId, entityId)
        this.props.activities.logNewActivity(localStorage.getItem('userId'), 'update', 2, this.state.editTaskId, 1, this.props.companyId)
        this.closeEdit()
      })
    } else {
      alert('Please check the form.  Required data is missing.')
    }
  }

  deleteTask(id) {
    if (confirm("Are you sure you want to delete this task?")) {
      this.props.tasks.deleteTask(id)
      this.props.companies.loadCompanyTasks(this.props.companyId)
      //Log activity //Log activity logNewActivity(userId, activity, activitySectionTypeId, activitySectionId, entityTypeId, entityId)
      this.props.activities.logNewActivity(localStorage.getItem('userId'), 'delete', 2, id, 1, this.props.companyId)
    }
  }

  formatActions(cell, row) {
    return (
      <div>
        <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={ <Tooltip id={'editTask-' + cell}>Edit Task</Tooltip> }><Button bsSize="small" bsStyle="warning" onClick={ (e) => { this.openEdit(cell) } }><i className="fa fa-pencil" aria-hidden="true"></i></Button></OverlayTrigger>
        <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={ <Tooltip id={'deleteTask-' + cell}>Delete Task</Tooltip> }><Button bsSize="small" bsStyle="danger" id={ cell } onClick={ () => { this.deleteTask(cell) } }><i className="fa fa-trash" aria-hidden="true"></i></Button></OverlayTrigger>
      </div>
    )
  }

  render() {

    const taskStateOptions = this.props.tasks.taskStates.map((state) => {
      return state.name
    })

    const taskPrioritiesOptions = this.props.tasks.data.map((priority) => {
      return priority.name
    })

    const options = {
      onAddRow: this.newTask.bind(this),
      defaultSortName: 'formattedDueDate',  // default sort column name
      defaultSortOrder: 'asc'  // default sort order
    }

    const tasksTable = (
      <div>
        <Button bsSize="small" bsStyle="info" onClick={this.open.bind(this)}><i className="fa fa-plus" aria-hidden="true"></i> New</Button>
        <BootstrapTable
            data={ this.props.data }
            striped={ true }
            hover={ true }
            pagination={ true }
            search={ true }
            options={ options }
            bordered={ false }>
            <TableHeaderColumn width="50" dataField="id" isKey={ true } dataSort={ true } dataAlign="center" hiddenOnInsert={ true } autoValue={ true }>ID</TableHeaderColumn>
            <TableHeaderColumn width="50" dataField="formattedCreatedDate" sortFunc={ this.sortByCreatedDate.bind(this) } dataSort={ true } editable={ false }>Created</TableHeaderColumn>
            <TableHeaderColumn width="50" dataField="formattedDueDate" sortFunc={ this.sortByDueDate.bind(this) } dataSort={ true } editable={ false }>Due</TableHeaderColumn>
            <TableHeaderColumn width="100" dataField="companyName" dataSort={ true } editable={ false }>Company</TableHeaderColumn>
            <TableHeaderColumn width="75" dataField="userFullName" dataSort={ true } editable={ false }>Created By</TableHeaderColumn>
            <TableHeaderColumn width="75" dataField="assignedUserName" dataSort={ true } editable={ false }>Assigned To</TableHeaderColumn>
            <TableHeaderColumn width="100" dataField="fullAddress" dataSort={ true } editable={ false }>Location</TableHeaderColumn>
            <TableHeaderColumn width="50" dataField="priority" dataSort={ true } editable={{ validator: Validators.validString, type: 'select', options: { values: taskPrioritiesOptions } }}>Priority</TableHeaderColumn>
            <TableHeaderColumn width="50" dataField="state" dataSort={ true } editable={{ validator: Validators.validString, type: 'select', options: { values: taskStateOptions } }}>State</TableHeaderColumn>
            <TableHeaderColumn width="100" dataField="task" dataSort={ true } editable={{ validator: Validators.validString }}>Task</TableHeaderColumn>
            <TableHeaderColumn width="50" dataField="id" hiddenOnInsert={ true } autoValue={ true } dataFormat={ this.formatActions.bind(this) }>Actions</TableHeaderColumn>
        </BootstrapTable>
      </div>
    )

    return (
      <div>
        <div>
          { tasksTable }
        </div>
        <div style={{ clear: 'both' }}></div>
        <Modal show={ this.state.showDetailsModal } onHide={ this.close.bind(this) }>
          <Modal.Header closeButton>
            <Modal.Title>New Task</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form horizontal name="newTaskForm">
              <FormGroup validationState={ this.getNewTaskAssignedUserValidationState() } >
                <Col><Typeahead clearButton labelKey="name" options={ this.props.users.all } onChange={ this.onAssignedUserChanged.bind(this) } placeholder="Choose a user..." /></Col>
              </FormGroup>
              <FormGroup>
                <Col sm={ 6 }><Dropdown data={ this.props.tasks.data } id="taskPriorityId" defaultValue={ this.props.tasks.data.id } onChange={ this.onTaskPriorityChanged.bind(this) }/></Col>
                <Col sm={ 6 }>
                  <FormGroup validationState={ this.getNewTaskDueDateValidationState() }>
                    <DatePicker id="dueDate" dateFormat="YYYY-MM-DD" value={ this.state.dueDate } onChange={ this.newTaskDueDateChanged.bind(this) } />
                  </FormGroup>
                </Col>
              </FormGroup>
                <FormGroup validationState={ this.getNewTaskTaskValidationState() } >
                  <Col sm={ 12 }><FormControl componentClass="textarea" placeholder="Task" id="newTask" onChange={ this.newTaskTaskChanged.bind(this) } /></Col>
                </FormGroup>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="danger" onClick={ this.close.bind(this) }><i className="fa fa-ban" aria-hidden="true"></i> Cancel</Button>
            <Button bsStyle="success" onClick={ this.newTask.bind(this) }><i className="fa fa-floppy-o" aria-hidden="true"></i> Save</Button>
          </Modal.Footer>
        </Modal>
        <Modal show={ this.state.showEditModal } onHide={ this.closeEdit.bind(this) }>
          <Modal.Header closeButton>
            <Modal.Title>Edit Task</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form horizontal name="editTaskForm">
              <Panel header={ <h3>Contact Information</h3> }>
                <Col sm={ 4 }>Phone: { this.state.companyPhone }</Col>
                <Col sm={ 6 }>Email: { this.state.companyEmail }</Col>
              </Panel>
              <Panel header={ <h3>Task Information</h3> }>
                <FormGroup validationState={ this.getEditTaskAssignedUserValidationState() } >
                  { /* <input type="hidden" id="editTaskId" /> */ }
                  <Col><Typeahead clearButton labelKey="name" options={ this.props.users.all } onChange={ this.onEditAssignedUserChanged.bind(this) } selected={ [{ id: this.state.editAssignedUserId, name: this.state.editAssignedUserName }] } placeholder="Choose a user..." /></Col>
                </FormGroup>
                <FormGroup>
                  <Col sm={ 4 }><Dropdown data={ this.props.tasks.data } id="editTaskPriorityId" onChange={ this.onEditTaskPriorityChanged.bind(this) } defaultValue={ this.state.editTaskPriorityId } /></Col>
                  <Col sm={ 4 }><Dropdown data={ this.props.tasks.taskStates } id="editTaskStateId" onChange={ this.onEditTaskStateChanged.bind(this) } defaultValue={ this.state.editTaskStateId } /></Col>
                  <Col sm={ 4 }>
                    <FormGroup validationState={ this.getEditTaskDueDateValidationState() }>
                      <DatePicker id="editDueDate" dateFormat="YYYY-MM-DD" value={ this.state.editDueDate } onChange={ this.editTaskDueDateChanged.bind(this) } />
                    </FormGroup>
                  </Col>
                </FormGroup>
                  <FormGroup validationState={ this.getEditTaskTaskValidationState() }>
                    <Col sm={ 12 }><FormControl componentClass="textarea" placeholder="Task" id="editTask" value={ this.state.editTask } onChange={ this.editTaskTaskChanged.bind(this) } /></Col>
                  </FormGroup>
                </Panel>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="danger" onClick={ this.closeEdit.bind(this) }><i className="fa fa-ban" aria-hidden="true"></i> Cancel</Button>
            <Button bsStyle="success" onClick={ this.saveTask.bind(this) }><i className="fa fa-floppy-o" aria-hidden="true"></i> Save</Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/tasksdetails.js